import React from 'react'
import FlexGroup from 'Components/FlexGroup'
import HelpOutline from 'Svgs/QuestionMarkCircle'
import PropTypes from 'prop-types'

const FAQPoint = ({ question, answer }) => (
  <FlexGroup
    style={{ minHeight: '170px' }}
    className="p-4 bg-gray-100 shadow-lg rounded-lg border border-indigo-200 mb-4"
    left={<HelpOutline className="text-indigo-500 h-6 align-middle mr-4" />}
    middle={
      <div>
        <p variant="h5" className="text-xl text-indigo-700">
          {question}
        </p>
        <p className="text-lg mt-1 text-gray-700">{answer}</p>
      </div>
    }
  />
)

FAQPoint.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
}

export default FAQPoint
